'use strict';

// Copy of client_core/components/toolTip with touch and keyboard support added. The base
// version binds hover only, which leaves tooltip content unreachable on touch devices and
// for keyboard users. Kept as a Red Kap override so the shared component is untouched.
function getTooltipTitle() {
  return $(this).find('.tooltip');
}
var TRIGGER_SELECTOR = '[data-toggle="tooltip"], .info-icon';
function enableTooltipsAndPopovers() {
  // Initialize tooltips. This also replaces the SFRA custom tooltip with the Bootstrap one
  // "trigger" is set to manual in order to add functionality to allow for tooltip to stay open on hover
  $(TRIGGER_SELECTOR).tooltip({
    title: getTooltipTitle,
    trigger: 'manual',
    sanitize: false // prevents removal of inline styles in tooltip content markup
  }).on('mouseenter', function (buttonEnterEvent) {
    var $button = $(buttonEnterEvent.target).closest('[data-toggle="tooltip"]');
    var showDelay = $button.data('delay') && $button.data('delay').show || 0;
    var hideDelay = $button.data('delay') && $button.data('delay').hide || 0;
    setTimeout(function () {
      $button.tooltip('show');
    }, showDelay);
    $('body').on('mouseleave', '.tooltip', function (tooltipLeaveEvent) {
      setTimeout(function () {
        $(tooltipLeaveEvent.target).closest('.tooltip').tooltip('hide');
      }, hideDelay);
    });
  }).on('mouseleave', function (buttonLeaveEvent) {
    var $button = $(buttonLeaveEvent.target).closest('[data-toggle="tooltip"]');
    var hideDelay = $button.data('delay') && $button.data('delay').hide || 0;
    setTimeout(function () {
      if (!$('.tooltip:hover').length) {
        $(buttonLeaveEvent.target).tooltip('hide');
      }
    }, hideDelay);
  });

  // Enables Bootstrap Popovers, which rely on the Tooltip library and provide extra functionality
  $('[data-toggle="popover"]').popover({
    html: true,
    trigger: 'focus',
    sanitize: false // prevents removal of inline styles in tooltip content markup
  });
}

/**
 * Tap and keyboard access. Namespaced and unbound first so that re-initialization
 * (tooltip:init fires after AJAX updates) does not stack duplicate handlers.
 */
function enableTouchAndKeyboardAccess() {
  // "aria-describedby" is set by Bootstrap only while a tooltip is shown, so it doubles
  // as the open/closed check for toggling.
  $('body').off('click.tooltipToggle').on('click.tooltipToggle', TRIGGER_SELECTOR, function (e) {
    e.preventDefault();
    var $trigger = $(this);
    var isShown = !!$trigger.attr('aria-describedby');
    $(TRIGGER_SELECTOR).not($trigger).tooltip('hide');
    $trigger.tooltip(isShown ? 'hide' : 'show');
  });
  $('body').off('focus.tooltipToggle').on('focus.tooltipToggle', TRIGGER_SELECTOR, function () {
    $(this).tooltip('show');
  });
  $('body').off('blur.tooltipToggle').on('blur.tooltipToggle', TRIGGER_SELECTOR, function () {
    $(this).tooltip('hide');
  });

  // Without these a tooltip opened by touch has no way to be closed, since mouseleave
  // never fires on a touch device.
  $(document).off('keydown.tooltipToggle').on('keydown.tooltipToggle', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      $(TRIGGER_SELECTOR).tooltip('hide');
    }
  });
  $('body').off('click.tooltipDismiss').on('click.tooltipDismiss', function (e) {
    if (!$(e.target).closest(TRIGGER_SELECTOR + ', .tooltip').length) {
      $(TRIGGER_SELECTOR).tooltip('hide');
    }
  });
}
module.exports = function () {
  enableTooltipsAndPopovers();
  enableTouchAndKeyboardAccess();
  $('body').on('tooltip:init', function () {
    enableTooltipsAndPopovers();
    enableTouchAndKeyboardAccess();
  });
};